import customEventListeners from '../listeners/custom-event-listeners';
import getLiveElement from '../accessors/get-live-element';
import instance from '../instance';

const hasElementAdditives = (elementId) => {
  const liveElement = getLiveElement(elementId);
  const hasDynamicContent = instance.driver.hasDynamicContent(liveElement);
  const hasCustomListeners = customEventListeners.hasFor(liveElement);

  return hasDynamicContent || hasCustomListeners;
};

export default hasElementAdditives;
